export const validationPillStrings = {
    LOWER_CASE: "Lower Case",
    UPPER_CASE: "Upper Case",
    DIGITS: "Digits",
    SYMBOLS: "Symbols"
};
